export default "__VITE_ASSET__D6aM5H9H__"